export default "__VITE_ASSET__Dxg5uStI__"